import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";
import SelectAccount from "../../../assets/selectAccount.png";

function SaveInGoal() {
  const { t } = useTranslation();
  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I save for a goal?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.ISavings.saveGoal.step1")}
        </p>
        <p>
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.ISavings.saveGoal.step2")}
        </p>
        <p>
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.ISavings.saveGoal.step3")}
        </p>
        <p>
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.ISavings.saveGoal.step4")}
        </p>
        <p>
          <span className="font-semibold">Step 5: </span>
          {t("helpCenter.ISavings.saveGoal.step5")}
          <br />
          <span className="font-semibold">Note: </span>
          {t("helpCenter.ISavings.saveGoal.note.part1")}
          <img
            src={SelectAccount}
            alt="icon"
            className="inline-flex w-[160px]"
          />
          {t("helpCenter.ISavings.saveGoal.note.part2")}
        </p>
        <p>
          <span className="font-semibold">Step 6: </span>
          {t("helpCenter.ISavings.saveGoal.step6")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default SaveInGoal;
